import { http } from "../base"

export async function listLogs(tenantId, keyword, pageNum = 1, pageSize = 20) {
  console.log("listLogs", tenantId);
  const response = await http.post(
    `/tenant/list_operationlogs`,
    { 
      'tenant_id': tenantId, 
      'keyword': keyword,
      'page_num': pageNum,       // 使用传入的 pageNum，而不是硬编码的 pageNo
      'page_size': pageSize,     // 使用传入的 pageSize
      'sort_field': 'operationTime',
      'sort_order': 'DESC'
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  
  if (response == null || response.status !== 200) {
    throw new Error(response?.data?.message || '获取操作日志列表失败');
  }
  return response.data;
}